import { useState, useEffect, useRef, useMemo } from 'react';
import { Button, Modal, Form, Col, Row } from 'react-bootstrap';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Trash from "../../../assets/images/delete.svg";
import View from '../../../assets/images/show.png';
import { toast } from 'react-toastify';
import Edit from "../../../assets/images/edit.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faGreaterThan, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { withRFSToken } from '../../../Services/axios.js';
import { SLOTPLANNINGMETADATA, SLOTPLANNINGWAREHOUSE, GETOWNERCODE, SLOTPLANNINGDOORSAVE, SLOTPLANNINGDOORDELETERESTORE, SLOTPLANNINGSETDOORCONFIGURATION, SLOTPLANNINGDOORUPDATE } from '../../../Utils/conts.js';
import Select from 'react-select'
import { useSelector } from "react-redux";
import TableGrid from "../../../Components/common/TableGrid";
import TableFilters from '../../../Components/common/TableGrid/TableFilters.js';
import { useGetDoorListQuery } from '../../../redux/services/SPL.js';
import green_check from '../../../assets/images/green_check.svg';
import red_cross from '../../../assets/images/red_cross.svg';
import save from '../../../assets/images/save.svg';
function DoorConfiguration() {

  const isMounted = useRef(false);
  const [modalShow, setModalShow] = useState(0);
  const [warehouselist, setWarehouselist] = useState([]);
  const [tripType, setTripType] = useState([]);
  const [cargoType, setCargoType] = useState([]);
  const [vehicleType, setVehicleType] = useState([]);
  const [specialCargoType, setSpecialCargoType] = useState([]);
  const [airlinePrefixOptions, setAirlinePrefixOptions] = useState([]);
  const [activeWarehouse, setActiveWarehouse] = useState(null);
  const [allData, setAlldata] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [confModal, setConfModal] = useState(false);
  const [doorDetailsModal, setDoorDetailsModal] = useState(false);
  const [deleteId, setDeleteId] = useState();
  const [activeDoorDetails, setActiveDoorDetails] = useState();
  const [activeDoorSelect, setActiveDoorSelect] = useState();
  const [isActive, setIsActive] = useState(true);

  const { pageDetails, filters, sortby, selectedRows, tab } = useSelector((state) => state.table);
  const filtersConfig = [
    {
      type: "input",
      field: "door_no",
      placeholder: "Door No.",
    },
    {
      type: "multiselect",
      field: "active_inactive",
      placeholder: "Active/Inactive",
      options: [
        { label: "Active", value: "a" },
        { label: "Inactive", value: "i" },
      ],
    },
  ];

  const handleEditDoorRow = (row) => {
    const tripTypeIds = row.door_trip_types?.map(t => t.trip_type_id) || [];
    const cargoTypeIds = row.door_cargo_types?.map(c => c.cargo_type_id) || [];
    const vehicleTypeIds = row.cargo_vehicle_types?.map(v => v.vehicle_type_id) || [];
    const airlinePrefixes = row.airline_special_doors?.map(a => a.airline_prefix) || [];
    const specialCargoTypeIds = row.cargo_special_doors?.map(s => s.cargo_type_id) || [];

    setFormData({
      warehouse_id: row.warehouse_id ?? activeWarehouse,
      door_no: row.door_no ?? '',
      door_id: row.id ?? '',
      activity_status: row.status ?? 1,
      trip_type_ids: tripTypeIds,
      cargo_type_ids: cargoTypeIds,
      vehicle_type_ids: vehicleTypeIds,
      side_loading: row.side_loading ?? 0,
      airline_assigment_rule: row.airline_assigment_rule ?? 1,
      airline_access_type: row.airline_access_type ?? '',
      airline_prefixes: airlinePrefixes,
      special_cargo_handling: row.special_cargo_handling ?? 0,
      special_cargo_handling_type: row.special_cargo_handling_type ?? '',
      special_cargo_types: specialCargoTypeIds
    });
    setModalShow(true);
  };

  const handleDeleteDoorRow = (row) => {
    setDeleteId(row.id);
    setConfModal(true);
  };

  const columns = [
    {
      label: "", field: "actions", enableSearch: false, cls: 'tw-6',
      renderCell: (row) => (<div className="grid_actions">
        <img src={Edit} alt="edit" className="door_edit" style={{ cursor: "pointer" }}
          onClick={(e) => {
            e.stopPropagation();
            handleEditDoorRow(row);
          }}
        />
        <img src={Trash} alt="delete" className="door_delete" style={{ cursor: "pointer" }}
          onClick={(e) => {
            e.stopPropagation();
            handleDeleteDoorRow(row);
          }}
        />
      </div>),
    },
    { label: "Door No.", field: "door_no", enableSearch: false, cls: 'tw-7' },
    {
  label: "Active/Inactive", field: "status_type", enableSearch: false, cls: 'tw-2',
  renderCell: (row) => {
    const isRowActive = row.status === 1;
    return (
      <div
        className={`switch ${isRowActive ? "active" : "inactive"}`}
        onClick={(e) => {
          e.stopPropagation();
          handleAddDoor({
            warehouse_id: row.warehouse_id,
            door_no: row.door_no,
            door_id: row.id,
            activity_status: isRowActive ? 0 : 1, // toggle
            trip_type_ids: row.door_trip_types?.map(t => t.trip_type_id) || [],
            cargo_type_ids: row.door_cargo_types?.map(c => c.cargo_type_id) || [],
            vehicle_type_ids: row.cargo_vehicle_types?.map(v => v.vehicle_type_id) || [],
            side_loading: row.side_loading ?? 0,
            airline_assigment_rule: row.airline_assigment_rule ?? 1,
            airline_access_type: row.airline_access_type ?? '',
            airline_prefixes: row.airline_special_doors?.map(a => a.airline_prefix) || [],
            special_cargo_handling: row.special_cargo_handling ?? 0,
            special_cargo_handling_type: row.special_cargo_handling_type ?? '',
            special_cargo_types: row.cargo_special_doors?.map(s => s.cargo_type_id) || []
          });
        }}
      >
        <div className="switch-knob">
          {isRowActive ? (
            <img src={green_check} alt="active" />
          ) : (
            <img src={red_cross} alt="inactive" />
          )}
        </div>
      </div>
    );
  },
},
    { label: "Trip Type", field: "trip_types", enableSearch: false, cls: 'tw-8' },
    { label: "Cargo Type", field: "cargo_types", enableSearch: false, cls: 'tw-8' },
    { label: "Vehicle Type", field: "vehicle_types", enableSearch: false, cls: 'tw-10' },
    { label: "Side Loading", field: "side_loading", enableSearch: false },
  ];

  const buildFilterParams = (filtersObj) => {
    const entries = Object.entries(filtersObj);
    const params = {};
    if (!entries.length) return params;
    entries.forEach(([field, value], index) => {
      params[`filtervalue${index}`] = value;
      params[`filtercondition${index}`] = "CONTAINS";
      params[`filteroperator${index}`] = 0;
      params[`filterdatafield${index}`] = field;
    });
    params.filterscount = entries.length;
    return params;
  };

  const queryParams = useMemo(() => {
    const filterParams = buildFilterParams(filters);
    const params = {
      warehouse_id: activeWarehouse,
      ...filterParams,
      pagenum: pageDetails.pagenum,
      pagesize: pageDetails.pagesize,
      recordstartindex: pageDetails.recordstartindex,
      recordendindex: pageDetails.recordendindex,
    };
    if (sortby?.sortdatafield) {
      params.sortdatafield = sortby.sortdatafield;
      params.sortorder = sortby.sortorder;
    }
    return params;
  }, [filters, pageDetails, sortby, activeWarehouse]);

  const { data: myData, isFetching, refetch } = useGetDoorListQuery(queryParams, {
    skip: !activeWarehouse,
    refetchOnMountOrArgChange: true,
  });

  const transformedRows = useMemo(() => {
    return (
      myData?.Rows?.map((item) => ({
        ...item,
        trip_types: item.door_trip_types?.map(t => t.trip_type?.name).join(', ') || '',
        cargo_types: item.door_cargo_types?.map(c => c.cargo_type?.name).join(', ') || '',
        vehicle_types: item.cargo_vehicle_types?.map(v => v.vehicle_type?.name).join(', ') || '',
      })) || []
    );
  }, [myData]);

  useEffect(() => {
    if (isMounted.current) return;
    fetchMetaData();
    fetchWareHouseData();
    fetchAirlinePrefix();
    isMounted.current = true;
  }, []);
  const airlineAccessOptions = [
    { label: 'Exclusive', value: 'E' },
    { label: 'Preferred', value: 'P' }
  ];
  const specialCargoHandlingTypeOptions = [
    { label: 'Exclusive', value: 'E' },
    { label: 'Preferred', value: 'P' }
  ];
  const initialFormData = {
    warehouse_id: '',
    door_no: '',
    activity_status: 1,
    trip_type_ids: [],
    cargo_type_ids: [],
    vehicle_type_ids: [],
    side_loading: 1,
    airline_assigment_rule: 0,
    airline_access_type: '',
    airline_prefixes: [],
    special_cargo_handling: 0,
    special_cargo_handling_type: '',
    special_cargo_types: [],
    inactive_reason: '',
  }
  const [formData, setFormData] = useState(initialFormData);

  const fetchMetaData = async () => {
    try {
      const res = await withRFSToken.post(SLOTPLANNINGMETADATA)
        .then(function (res) {
          const trip_type = res.data.response_data.trip_type;
          setTripType(trip_type.map(w => ({
            label: w.name,
            value: w.id
          })));
          const cargo_type = res.data.response_data.cargo_type;
          setCargoType(cargo_type.map(w => ({
            label: w.name,
            value: w.id
          })));
          const vehicle_type = res.data.response_data.vehicle_type;
          setVehicleType(vehicle_type.map(w => ({
            label: w.name,
            value: w.id
          })));
          const special_cargo_type = res.data.response_data.special_cargo_type;
          setSpecialCargoType(special_cargo_type.map(w => ({
            label: w.name,
            value: w.id
          })));
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchWareHouseData = async () => {
    try {
      let Handler_stn = localStorage.getItem('Handler_stn');
      if (!Handler_stn) {
        return;
      }
      Handler_stn = JSON.parse(Handler_stn);
      const res = await withRFSToken.post(SLOTPLANNINGWAREHOUSE, { org_station_id: Handler_stn.org_station_id })
        .then(function (res) {
          const innerData = res.data.response_data;
          setWarehouselist(innerData.map(w => ({
            label: w.name,
            value: w.id,
            doors_count: w.doors_count,
          })));
          if (innerData.length > 0) {
            setActiveWarehouse(innerData[0].id);
            setFormData(prev => ({ ...prev, warehouse_id: innerData[0].id }));
          }
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchAirlinePrefix = async () => {
    try {
      const res = await withRFSToken.post(GETOWNERCODE)
        .then(function (res) {
          const innerData = res.data.response_data;
          setAirlinePrefixOptions(innerData.map(w => ({
            label: w.IATA,
            value: w.IATA
          })));
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    if (name == "door_no") {
      value = value.toUpperCase();
    }
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (name, selectedOption, isMulti = false) => {
    setFormData(prev => ({
      ...prev,
      [name]: isMulti
        ? (selectedOption || []).map(opt => opt.value)
        : selectedOption?.value ?? ''
    }));
  };

  const handleBooleanChange = (name, boolValue) => {
    setFormData(prev => ({ ...prev, [name]: boolValue }));
  };

  const handleAddButtonClick = () => {
    setFormData({...initialFormData, warehouse_id: activeWarehouse});
    setModalShow(true);
  };

  const handleModalClose = () => {
    setModalShow(false);
  };

  const handleAddDoor = async (existingData = null) => {
  const payload = existingData || formData;
  try {
    const res = await withRFSToken.post(SLOTPLANNINGDOORSAVE, payload);
    if (res.data.response_code == 200) {
      toast.success(res.data.response_msg);
      if (!existingData) {
        // only reset/close modal on manual add/edit
        setModalShow(false);
        setFormData({
          warehouse_id: '', door_no: '', activity_status: 1,
          trip_type_ids: [], cargo_type_ids: [], vehicle_type_ids: [],
          side_loading: 1, airline_assigment_rule: 1, airline_access_type: '',
          airline_prefixes: [], special_cargo_handling: 1,
          special_cargo_handling_type: '', special_cargo_types: []
        });
      }
      fetchWareHouseData();
      refetch();
    } else {
      toast.error(res.data.response_msg);
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};

  const handleUpdateDoor = async (door_id, action, actionType) => {
    setActiveDoorSelect(door_id);
    let action_type;
    if (action == 1) {
      action_type = "C";
    }
    if (action == 0) {
      action_type = actionType;
    }
    const alldata = {
      door_id: door_id,
      action: action,
      action_type: action_type,
      slot_details: finalSlotDetails
    };
    try {
      const res = await withRFSToken.post(SLOTPLANNINGDOORUPDATE, alldata)
        .then(function (res) {
          if (res.data.response_code == 200) {
            toast.success(res.data.response_msg);
          } else if (res.data.response_code == 403) {
            setDoorDetailsModal(true);
            setActiveDoorDetails(res.data?.response_data);
          } else if (res.data.response_code == 402) {
            toast.error(res.data.response_msg);
          } else {
            toast.error(res.data.response_msg);
          }
          refreshPageData();
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };


  const handleWarehouseClick = (warehouseId) => {
    setActiveWarehouse(warehouseId);
    setFormData(prev => ({ ...prev, warehouse_id: warehouseId }));
  };

  const gridRefs = useRef({});
  // useEffect(() => {
  //   if (activeWarehouse !== null && activeWarehouse !== undefined && activeWarehouse !== '') {
  //     loadGrid();
  //   }
  // }, [activeWarehouse]);
  // useEffect(() => {
  //   console.log(formData);

  // }, [formData]);


  const handleConfirmation = (confirm) => {
    if (confirm) {
      handleDoorDelete(deleteId)
      setConfModal(false);
    } else {
      setDeleteId(0);
      closeConfirm();
    }
  };
  const closeConfirm = () => {
    setConfModal(false);
  }
  const handleDoorDelete = async (commentId) => {
    const res = await withRFSToken.post(SLOTPLANNINGDOORDELETERESTORE, { 'door_id': deleteId })
    if (res.data.response_code == 200) {
      if (res.data.response_code == 200) {
        toast.success(res.data.response_msg);
        closeConfirm();
        fetchWareHouseData();
        refetch(); 
      } else {
        toast.error(res.data.response_msg);
      }
    } else {
      toast.error(res.data.response_msg);
    }
  };
  const refreshPageData = () => {
    fetchWareHouseData();
    refreshGrid();
  }
  const refreshGrid = () => {
    const grid = window.$(gridRefs.current);
    grid.jqxGrid('updatebounddata');
    grid.jqxGrid('refresh');
  };
  let Handler_stn = localStorage.getItem('Handler_stn');
  if (Handler_stn) {
    Handler_stn = JSON.parse(Handler_stn);
  }
  const [slotStatuses, setSlotStatuses] = useState({});
  const [switchData, setSwitchData] = useState(Handler_stn?.door_configuration);
  const switchChange = (e) => {
    const isChecked = e.target.checked;
    setSwitchData(isChecked);
    Handler_stn.door_configuration = isChecked;
    setDoorConfiguration(isChecked, Handler_stn.org_station_id);
    localStorage.setItem('Handler_stn', JSON.stringify(Handler_stn));
  }
  const setDoorConfiguration = async (door_configuration, org_station_id) => {
    try {
      const res = await withRFSToken.post(SLOTPLANNINGSETDOORCONFIGURATION, {
        "org_station_id": org_station_id,
        "door_configuration": door_configuration
      })
    } catch (error) {
      console.error('Error fetching warehouse data:', error);
    }
  };
  const handleConfirmDoorDetails = (confirm) => {
    if (confirm) {
      // handleDoorDelete(deleteId)
      // setConfModal(false);
      handleUpdateDoor(activeDoorSelect, 0, "C");
      setDoorDetailsModal(false);
    } else {
      setDeleteId(0);
      setDoorDetailsModal(false);
    }
  };

  useEffect(() => {
    if (activeDoorDetails?.assigned_slots?.length) {
      const defaultStatuses = {};
      activeDoorDetails.assigned_slots.forEach(slot => {
        const slotId = slot.old_slot?.slot_id;
        if (slotId) {
          defaultStatuses[slotId] = 1; // default ON
        }
      });
      setSlotStatuses(defaultStatuses);
    }
  }, [activeDoorDetails]);

  // const updatedAssigned = activeDoorDetails?.assigned_slots?.map((slot) => ({
  //   ...slot,
  //   status: slotStatuses[slot.old_slot.slot_id] ?? 0
  // }));

  // const finalSlotDetails = {
  //   assigned_slots: updatedAssigned,
  //   not_assigned_slots: activeDoorDetails?.not_assigned_slots
  // };

  const finalSlotDetails = {
    assigned_slots: activeDoorDetails?.assigned_slots?.map(slot => ({
      ...slot,
      status: slotStatuses?.[slot.old_slot?.slot_id] ?? 0,
    })) ?? [],
    not_assigned_slots: activeDoorDetails?.not_assigned_slots ?? [],
  };

  const SBack = localStorage.getItem('SettingsBack');

  return (
    // <div className="">
    //   <Header logo_url={SBack ? SBack : '/PlanningDashboard'} sBackUrl={SBack ? SBack : '/PlanningDashboard'} />
    //   <div className="main-panel">
    //     <div className="row">
    //       <LeftSettings />
    // <div className='col-9 col-xxl-9 stting_right'>
    // <div className='settingbg_right'>

      <>
          <div>
            <h4>Door Configuration</h4>
            <p>Manage and configure doors for the warehouse(s).</p>
          </div>

        {/* / */}
        {/* <div className='col-6'> */}
        {/* <div> */}
        <hr />
        <div className="d-flex align-items-center mb-3">
          <Button variant="primary createplan" onClick={handleAddButtonClick}>
            <FontAwesomeIcon icon={faPlus} /> Add Door
          </Button>
          <TableFilters filtersConfig={filtersConfig} />
        </div>
        {/* </div> */}
        {/* </div> */}

        {/* </div> */}
        <Tabs id="warehouse-tabs" activeKey={activeWarehouse} onSelect={handleWarehouseClick} className="booking_tab">
          {warehouselist?.map((warehouse) => (
            <Tab
              eventKey={warehouse.value}
              key={warehouse.value}
              title={
                <>
                  <span>
                    {warehouse.label}
                    <span className="rabadge badge bg-primary ms-2 ssss">{warehouse.doors_count}</span>
                  </span>
                </>
              }
            />
          ))}
        </Tabs>
        {/* {!isLoading && (
                  <div ref={gridRefs} className="staion_grid" />
                )} */}
                <div className='setting_table'>

                  <TableGrid
          columns={columns}
          rows={transformedRows}
          checkboxSelection={true}
          totalRecords={myData?.TotalRows || 0}
          onClickRow={(row) => {
            console.log("Clicked Row:", row);
          }}
          loading={isFetching}
        />

                </div>
        

        <Modal show={modalShow} centered onHide={handleModalClose} className='addfrom add_door soltPlanning_doorConfig_modal'>
          <Modal.Header closeButton>
            <Modal.Title>Add Door <br /> <span>Add new door to the system</span></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col sm="12" className="mb-1">
                <Form.Label>Warehouse</Form.Label>
                <Select
                  name="warehouse_id"
                  options={warehouselist}
                  value={warehouselist?.find(opt => opt.value == activeWarehouse)}
                  onChange={(val) => handleSelectChange('warehouse_id', val)}
                  placeholder="Warehouse"
                // className="form-control"
                />
              </Col>
              <Col sm="6" className="mb-1">
                <Form.Label>Door No</Form.Label>
                <input
                  type="text"
                  name="door_no"
                  value={formData.door_no}
                  onChange={handleInputChange}
                  className="form-control"
                  placeholder="Total Pieces"
                />
              </Col>
              {/* <Col sm="6" className="mb-2">
                        <Form.Label>Status</Form.Label>
                        <div className='act_status'>
                          <Button
                            type="button"
                            variant={formData.activity_status === 1 ? 'success' : 'light'}
                            onClick={() => handleSelectChange('activity_status', { value: 1 })}
                          >
                            Active
                          </Button>
                          <Button
                            type="button"
                            variant={formData.activity_status === 0 ? 'danger' : 'light'}
                            onClick={() => handleSelectChange('activity_status', { value: 0 })}
                          >
                            Inactive
                          </Button>
                        </div>
                      </Col> */}
              <Col sm="6" className="mb-1">
                <div className="status-wrapper">
                  <Form.Label>Status</Form.Label>

                  <div
                     className={`switch ${formData.activity_status === 1 ? "active" : "inactive"}`}
                      onClick={() => setFormData(prev => ({ 
                        ...prev, 
                        activity_status: prev.activity_status === 1 ? 0 : 1,
                        inactive_reason: '' 
                      }))}
                  >
                    <div className="switch-knob">
                     {formData.activity_status === 1 ? "Active" : "Inactive"}
                    </div>
                  </div>
                </div>
              </Col>
             {formData.activity_status === 0 && (
                  <Col sm="12" className="mb-0">
                    <div className='inactive_reason_dv'>
                      <Form.Label>Reason for Inactivation</Form.Label>
                      <input
                        type="text"
                        name="inactive_reason"
                        value={formData.inactive_reason}
                        onChange={handleInputChange}
                        className="form-control"
                        placeholder="Reason for Inactivation"
                      />
                    </div>
                  </Col>
                )}
              <Col sm="6" className="mb-1">
                <Form.Label>Trip Type</Form.Label>
                <Select
                  name="trip_type_ids"
                  isMulti
                  options={tripType}
                  value={tripType.filter(opt => formData.trip_type_ids.includes(opt.value))}
                  onChange={(val) => handleSelectChange('trip_type_ids', val, 1)}
                  placeholder="Trip Type"
                />
              </Col>
              <Col sm="6" className="mb-1">
                <Form.Label>Cargo Type</Form.Label>
                <Select
                  name="cargo_type_ids"
                  isMulti
                  options={cargoType}
                  value={cargoType.filter(opt => formData.cargo_type_ids.includes(opt.value))}
                  onChange={(val) => handleSelectChange('cargo_type_ids', val, 1)}
                  placeholder="Cargo Type"
                />
              </Col>
              <Col sm="6" className="mb-1">
                <Form.Label>Vehicle Type</Form.Label>
                <Select
                  name="vehicle_type_ids"
                  isMulti
                  options={vehicleType}
                  value={vehicleType.filter(opt => formData.vehicle_type_ids.includes(opt.value))}
                  onChange={(val) => handleSelectChange('vehicle_type_ids', val, 1)}
                  placeholder="Vehicle Type"
                />
              </Col>
              <Col sm="6" className="mb-1">
                <Form.Label>Side Loading</Form.Label>
                <div className='frm_chck_wrap'>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="side_loading"
                      className="form-check-input"
                      checked={formData.side_loading === 1}
                      onChange={() => handleBooleanChange('side_loading', 1)}
                      id="side_loading_yes"
                    />
                    <Form.Label className="form-check-label mb-0" htmlFor='side_loading_yes'>Yes</Form.Label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="side_loading"
                      className="form-check-input"
                      checked={formData.side_loading === 0}
                      onChange={() => handleBooleanChange('side_loading', 0)}
                      id="side_loading_no"
                    />
                    <Form.Label className="form-check-label mb-0" htmlFor='side_loading_no'>No</Form.Label>
                  </div>
                </div>
              </Col>
              <hr />
              <Col sm="12">
                <Form.Label>Airline Access Type</Form.Label>
                <div className='frm_chck_wrap'>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="airline_assigment_rule"
                      className="form-check-input"
                      checked={formData.airline_assigment_rule === 1}
                      onChange={() => handleBooleanChange('airline_assigment_rule', 1)}
                      id="airline_assigment_rule_1"
                    />
                    <Form.Label className="form-check-label mb-0" htmlFor='airline_assigment_rule_1'>Yes</Form.Label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="airline_assigment_rule"
                      className="form-check-input"
                      checked={formData.airline_assigment_rule === 0}
                      onChange={() => handleBooleanChange('airline_assigment_rule', 0)}
                      id="airline_assigment_rule_0"
                    />
                    <Form.Label className="form-check-label mb-0" htmlFor='airline_assigment_rule_0'>No</Form.Label>
                  </div>
                </div>
              </Col>
              {formData.airline_assigment_rule === 1 && (
                <>
                  <Col sm="6" className="mb-2">
                    <Form.Label>Airline Access</Form.Label>
                    <Select
                      name="airline_access_type"
                      options={airlineAccessOptions}
                      value={airlineAccessOptions.find(opt => opt.value === formData.airline_access_type)}
                      onChange={(val) => handleSelectChange('airline_access_type', val)}
                      placeholder="Airline Access"
                    />
                  </Col>
                  <Col sm="6" className="mb-2">
                    <Form.Label>Airline Prefix</Form.Label>
                    <Select
                      name="airline_prefixes"
                      isMulti
                      options={airlinePrefixOptions}
                      value={airlinePrefixOptions.filter(opt => formData.airline_prefixes.includes(opt.value))}
                      onChange={(val) => handleSelectChange('airline_prefixes', val, 1)}
                      placeholder="Airline Prefix"
                    />
                  </Col>
                </>
              )}
              <hr />
              <Col sm="12">
                <Form.Label>Special Cargo Handling</Form.Label>
                <div className='frm_chck_wrap'>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="special_cargo_handling"
                      className="form-check-input"
                      checked={formData.special_cargo_handling === 1}
                      onChange={() => handleBooleanChange('special_cargo_handling', 1)}
                      id="special_cargo_handling_1"
                    />
                    <Form.Label className="form-check-label mb-0" htmlFor='special_cargo_handling_1'>Yes</Form.Label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="special_cargo_handling"
                      className="form-check-input"
                      checked={formData.special_cargo_handling === 0}
                      onChange={() => handleBooleanChange('special_cargo_handling', 0)}
                      id="special_cargo_handling_0"
                    />
                    <Form.Label className="form-check-label mb-0" htmlFor='special_cargo_handling_0'>No</Form.Label>
                  </div>
                </div>
              </Col>
              {formData.special_cargo_handling === 1 && (
                <>
                  <Col sm="6" className="mb-2">
                    <Form.Label>Special Cargo Handling Type</Form.Label>
                    <Select
                      name="special_cargo_handling_type"
                      options={specialCargoHandlingTypeOptions}
                      value={specialCargoHandlingTypeOptions.find(opt => opt.value === formData.special_cargo_handling_type)}
                      onChange={(val) => handleSelectChange('special_cargo_handling_type', val)}
                      placeholder="Handling Type"
                    />
                  </Col>
                  <Col sm="6" className="mb-2">
                    <Form.Label>Special Cargo Type</Form.Label>
                    <Select
                      name="special_cargo_types"
                      isMulti
                      options={specialCargoType}
                      value={specialCargoType.filter(opt => formData.special_cargo_types.includes(opt.value))}
                      onChange={(val) => handleSelectChange('special_cargo_types', val, 1)}
                      placeholder="Special Cargo Type"
                    />
                  </Col>
                </>
              )}
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Col md={3}>
              {/* <Button variant="primary" onClick={() => handleAddDoor()}>
                {formData.door_id ? 'Update' : 'Add'} Door
              </Button> */}
               <Button className="save_btn" onClick={() => handleAddDoor()}><img src={save} alt="save" />Save</Button>
            </Col>
          </Modal.Footer>
        </Modal>

        <Modal show={confModal} onHide={closeConfirm} className="addfrom change_type" centered>
          <Modal.Header closeButton onClick={closeConfirm}></Modal.Header>
          <Modal.Body>
            <h3>The Door will be deleted. </h3>
            <p>Are you sure you want to continue?</p>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex w-50 mx-auto are_bottom">
              <Button variant="secondary" onClick={() => handleConfirmation(false)}> No</Button>
              <Button variant="primary" onClick={() => handleConfirmation(true)}> Yes </Button>
            </div>
          </Modal.Footer>
        </Modal>

        <Modal show={doorDetailsModal} className="addfrom change_type" centered size="lg">
          <Modal.Header closeButton onClick={() => handleConfirmDoorDetails(false)}></Modal.Header>
          <Modal.Body>
            <h3>Door Inactive - Door 5</h3>
            <p>If you choose inactive the door all slot change to other door</p>

            {activeDoorDetails?.assigned_slots?.map((element, index) => (
              <div className="door_inactive" key={index}>
                <div className='d-flex justify-content-between align-items-center'>

                  <h4>{element.trip_type}</h4>
                  <Form.Check
                    type="switch"
                    id={`switch-${element.old_slot.slot_id}`}
                    checked={slotStatuses[element.old_slot.slot_id] === 1}
                    onChange={(e) => {
                      const newStatus = e.target.checked ? 1 : 0;
                      setSlotStatuses(prev => ({
                        ...prev,
                        [element.old_slot.slot_id]: newStatus
                      }));
                    }}
                  />

                </div>
                <div className='d-flex justify-content-between align-items-center'>
                  <div>
                    <ul>
                      <li>
                        <span>Original</span>
                        <span>Door 5</span>
                      </li>
                      <li>
                        <span>13 Sep</span>
                        <span>7:00 - 8:00</span>
                      </li>
                    </ul>
                    {/* {element.old_slot.door_no}<br />
                              {element.old_slot.start_time}<br />
                              {element.old_slot.end_time} */}
                  </div>
                  <div>
                    <FontAwesomeIcon icon={faArrowRight} />
                  </div>
                  <div >
                    <ul>
                      <li>
                        <span>Changes</span>
                        <span>Door 1</span>
                      </li>
                      <li>
                        <span>14 Sep </span>
                        <span>8:00 - 9:00</span>
                      </li>
                    </ul>
                    {/* {element.new_slot.door_no}<br />
                              {element.new_slot.start_time}<br />
                              {element.new_slot.end_time} */}
                  </div>
                </div>
              </div>
            ))}

          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex w-50 mx-auto are_bottom">
              <Button variant="secondary" onClick={() => handleConfirmDoorDetails(false)}> No</Button>
              <Button variant="primary" onClick={() => handleConfirmDoorDetails(true)}> Yes </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </>
   
    // </div>
    //     </div>
    //   </div>
    // </div>
  )

}

export default DoorConfiguration